export const SET_API = 'parser/api/setApi'
